import Vue from "vue";
import Router from "vue-router";
import LoginDialog from "./views/loginDialog/LoginDialog.vue";
import TeaLoginDialog from "./views/loginDialog/TeaLoginDialog.vue";
import StuLoginDialog from "./views/loginDialog/StuLoginDialog.vue";
import HLoginDialog from "./views/loginDialog/HLoginDialog.vue";
import VLoginDialog from "./views/loginDialog/VLoginDialog.vue";
//更新密码功能实现有问题，即将废弃
import ChangePwd from "./views/changepwd/index.vue";
import StuChangePwd from "./views/changepwd/stuIndex.vue";
import TeaChangeByPwd from "./views/changeByPwd/teaIndex.vue";
import StuChangeByPwd from "./views/changeByPwd/stuIndex.vue";
//推荐使用的更新密码功能
import UpdatePwd from "./views/updatePwd/index.vue";
import StuUpdatePwd from "./views/updatePwd/stuIndex.vue";
import TeaUpdateByPwd from "./views/updateByPwd/teaIndex.vue";
import StuUpdateByPwd from "./views/updateByPwd/stuIndex.vue";
// 跳转H5下载
import learnDownload from "./views/learnDownload/index.vue"
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/loginDialog",
      name: "loginDialog",
      component: LoginDialog
    },
    {
      path: "/teaLoginDialog",
      name: "teaLoginDialog",
      component: TeaLoginDialog
    },
    {
      path: "/stuLoginDialog",
      name: "stuLoginDialog",
      component: StuLoginDialog
    },
    {
      path: "/hLoginDialog",
      name: "hLoginDialog",
      component: HLoginDialog
    },
    {
      path: "/vLoginDialog",
      name: "vLoginDialog",
      component: VLoginDialog
    },
    {
      path: "/changepwd",
      name: "changepwd",
      component: ChangePwd
    },
    {
      path: "/stuchangepwd",
      name: "stuchangepwd",
      component: StuChangePwd
    },
    {
      path: "/teachangebypwd",
      name: "teachangebypwd",
      component: TeaChangeByPwd
    },
    {
      path: "/stuchangebypwd",
      name: "stuchangebypwd",
      component: StuChangeByPwd
    },
    {
      path: "/updatepwd",
      name: "updatepwd",
      component: UpdatePwd
    },
    {
      path: "/stuupdatepwd",
      name: "stuupdatepwd",
      component: StuUpdatePwd
    },
    {
      path: "/teaupdatebypwd",
      name: "teaupdatebypwd",
      component: TeaUpdateByPwd
    },
    {
      path: "/stuupdatebypwd",
      name: "stuupdatebypwd",
      component: StuUpdateByPwd
    },
    {
      path: "/learndownload/:appId/:deviceType",
      name: "learnDownload",
      component: learnDownload
    }
  ]
});
